import React, { useEffect, useState } from "react";
import userdashboardlogo from "../../images/user-dashboard-logo.svg";
import { Link } from "react-router-dom";
import { handleToggleCollapse } from "./Collapsfunction";
import langicon from "../../images/langicon.png";
import { useTranslation } from "react-i18next";
import { callApi } from "./API/Api";
import { Navbar } from "react-bootstrap";
import LanguageSwitcher from "./LanguageSwitcher";
import useLanguage from "./useLanguage";
import { getBaseUrl } from "./BaseUrl";
import { useNavigate, useParams } from "react-router-dom";
const Header = () => {
  const { t } = useTranslation();
  let base_url = getBaseUrl()
  useEffect(() => {
    if (window.googleTranslateScriptLoaded) return;

    window.googleTranslateScriptLoaded = true;

    const addScript = document.createElement("script");
    addScript.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    addScript.async = true;

    document.body.appendChild(addScript);

    window.googleTranslateElementInit = () => {
      if (!window.translateElementInitialized) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            autoDisplay: false,
          },
          "google_translate_element",
        );
        window.translateElementInitialized = true;
      }
    };
  }, []);
  const handleGetInTouchClick = () => {
    const element = document.getElementById("get-in-touch");

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }

    window.dispatchEvent(new Event("highlight-contact"));
  };

  return (
    <header className="header_bg">
      <Navbar collapseOnSelect expand="lg">
        <div className="container">
          <div className="logonavbar">
            <div className="site_logo">
              <Link to={`${base_url}`}>
                <img src={userdashboardlogo} alt="" />
              </Link>
            </div>
          </div>
          <Navbar.Collapse id="responsive-navbar-nav">
            <ul className="navbar-nav">
              <li className="nav-item active">
                <Link className="nav-link" to={`${base_url}`}>
                  {t("Home")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={`${base_url}login`}>
                  {t("Trading")}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to=""
                  onClick={(e) => e.preventDefault()}
                >
                  {t("Education")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={`${base_url}login`}>
                  {t("Support")}
                </Link>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link" href="javascript:;">More</a>
              </li>  */}

              <div className="nav-item dropdown">
                <a
                  type="button"
                  className="moreoptionmenu position-relative nav-link dropdown-toggle"
                  data-bs-toggle="collapse"
                  // href="#moredropdownMenu"
                  aria-controls="notificationsCollapse"
                  aria-labelledby="moredropdownMenu"
                  role="button"
                  aria-expanded="false"
                  onClick={() => handleToggleCollapse("moredropdownMenu")}
                >
                  {t("More")}
                </a>
                <div className="dropdown-menu" id="moredropdownMenu">
                  <ul className="dropdown-menu-ul">
                    <li>
                      <Link className="dropdown-item" to={`${base_url}about`}>
                        {t("About the Company")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`${base_url}contacts`}
                      >
                        {t("Contacts")}
                      </Link>
                    </li>
                    {/* <li>
                      <Link className="dropdown-item  " to="" onClick={(e) => e.preventDefault()}>
                        {t("Education")}

                      </Link>
                    </li> */}
                    <li>
                      <Link className="dropdown-item" to={`${base_url}reviews`}>
                        {t("Reviews")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`${base_url}regulation`}
                      >
                        {t("Regulation")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`${base_url}termsandconditions`}
                      >
                        {t("Terms and Conditions")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`${base_url}amlandkycpolicy`}
                      >
                        {t("AML and KYC policy")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`${base_url}privacypolicy`}
                      >
                        {t("Privacy policy")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`${base_url}paymentpolicy`}
                      >
                        {t("Payment policy")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`${base_url}informationdisclosure`}
                      >
                        {t("Information disclosure")}
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        className="dropdown-item"
                        onClick={handleGetInTouchClick}
                      >
                        Get In Touch
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </ul>
          </Navbar.Collapse>

          <div className="button_group">
            <Link className="nav-link" to={`${base_url}login`}>
              {t("Login")}
            </Link>
            <Link className="btn site_grdbtn" to={`${base_url}signup`}>
              {t("Start Free Trial")}
            </Link>
            <LanguageSwitcher />
          </div>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        </div>
      </Navbar>
    </header>
  );
};

export default Header;
